import { ReactElement } from "react";
import AbkhaziaSvg from "@/assets/svg/flags/abkhaziaSvg";
import AfghanistanSvg from "@/assets/svg/flags/afghanistanSvg";
import AlandislandsSvg from "@/assets/svg/flags/aland islandsSvg";
import AlbaniaSvg from "@/assets/svg/flags/albaniaSvg";
import AlgeriaSvg from "@/assets/svg/flags/AlgeriaSvg";
import AmericansamoaSvg from "@/assets/svg/flags/american samoaSvg";
import AndorraSvg from "@/assets/svg/flags/andorraSvg";
import AngolaSvg from "@/assets/svg/flags/angolaSvg";
import AnguillaSvg from "@/assets/svg/flags/anguillaSvg";
import AntiguaandbarbudaSvg from "@/assets/svg/flags/antigua and barbudaSvg";
import ArgentinaSvg from "@/assets/svg/flags/argentinaSvg";
import ArmeniaSvg from "@/assets/svg/flags/armeniaSvg";
import ArubaSvg from "@/assets/svg/flags/arubaSvg";
import AustraliaSvg from "@/assets/svg/flags/australiaSvg";
import AustriaSvg from "@/assets/svg/flags/austriaSvg";
import AzerbaijanSvg from "@/assets/svg/flags/azerbaijanSvg";
import AzoresislandsSvg from "@/assets/svg/flags/azores islandsSvg";
import BahamasSvg from "@/assets/svg/flags/bahamasSvg";
import BahrainSvg from "@/assets/svg/flags/bahrainSvg";
import BalearicislandsSvg from "@/assets/svg/flags/balearic islandsSvg";
import BangladeshSvg from "@/assets/svg/flags/bangladeshSvg";
import BarbadosSvg from "@/assets/svg/flags/barbadosSvg";
import BasquecountrySvg from "@/assets/svg/flags/basque countrySvg";
import BelarusSvg from "@/assets/svg/flags/belarusSvg";
import BelgiumSvg from "@/assets/svg/flags/belgiumSvg";
import BelizeSvg from "@/assets/svg/flags/belizeSvg";
import BeninSvg from "@/assets/svg/flags/beninSvg";
import BermudaSvg from "@/assets/svg/flags/bermudaSvg";
import BhutanSvg from "@/assets/svg/flags/bhutanSvg";
import BoliviaSvg from "@/assets/svg/flags/boliviaSvg";
import BonaireSvg from "@/assets/svg/flags/bonaireSvg";
import BosniaandherzegovinaSvg from "@/assets/svg/flags/bosnia and herzegovinaSvg";
import BotswanaSvg from "@/assets/svg/flags/botswanaSvg";
import BrazilSvg from "@/assets/svg/flags/brazilSvg";
import BritishcolumbiaSvg from "@/assets/svg/flags/british columbiaSvg";
import BritishindianoceanterritorySvg from "@/assets/svg/flags/british indian ocean territorySvg";
import BritishvirginislandsSvg from "@/assets/svg/flags/british virgin islandsSvg";
import BruneiSvg from "@/assets/svg/flags/bruneiSvg";
import BulgariaSvg from "@/assets/svg/flags/bulgariaSvg";
import BurkinafasoSvg from "@/assets/svg/flags/burkina fasoSvg";
import BurundiSvg from "@/assets/svg/flags/burundiSvg";
import CambodiaSvg from "@/assets/svg/flags/cambodiaSvg";
import CameroonSvg from "@/assets/svg/flags/cameroonSvg";
import CanadaSvg from "@/assets/svg/flags/canadaSvg";
import CanaryislandsSvg from "@/assets/svg/flags/canary islandsSvg";
import CapeverdeSvg from "@/assets/svg/flags/cape verdeSvg";
import CaymanislandsSvg from "@/assets/svg/flags/cayman islandsSvg";
import CentralafricanrepublicSvg from "@/assets/svg/flags/central african republicSvg";
import CeutaSvg from "@/assets/svg/flags/ceutaSvg";
import ChadSvg from "@/assets/svg/flags/chadSvg";
import ChileSvg from "@/assets/svg/flags/chileSvg";
import ChinaSvg from "@/assets/svg/flags/chinaSvg";
import CocosislandSvg from "@/assets/svg/flags/cocos islandSvg";
import ColombiaSvg from "@/assets/svg/flags/colombiaSvg";
import ComorosSvg from "@/assets/svg/flags/comorosSvg";
import CookislandsSvg from "@/assets/svg/flags/cook islandsSvg";
import CorsicaSvg from "@/assets/svg/flags/corsicaSvg";
import CostaricaSvg from "@/assets/svg/flags/costa ricaSvg";
import CroatiaSvg from "@/assets/svg/flags/croatiaSvg";
import CubaSvg from "@/assets/svg/flags/cubaSvg";
import CuracaoSvg from "@/assets/svg/flags/curacaoSvg";
import CyprusSvg from "@/assets/svg/flags/cyprusSvg";
import CzechrepublicSvg from "@/assets/svg/flags/czech republicSvg";
import DemocraticrepublicofcongoSvg from "@/assets/svg/flags/democratic republic of congoSvg";
import DenmarkSvg from "@/assets/svg/flags/denmarkSvg";
import DjiboutiSvg from "@/assets/svg/flags/djiboutiSvg";
import DominicaSvg from "@/assets/svg/flags/dominicaSvg";
import DominicanrepublicSvg from "@/assets/svg/flags/dominican republicSvg";
import EasttimorSvg from "@/assets/svg/flags/East TimorSvg";
import EcuadorSvg from "@/assets/svg/flags/ecuadorSvg";
import EgyptSvg from "@/assets/svg/flags/egyptSvg";
import ElsalvadorSvg from "@/assets/svg/flags/el salvadorSvg";
import EnglandSvg from "@/assets/svg/flags/englandSvg";
import EquatorialguineaSvg from "@/assets/svg/flags/equatorial guineaSvg";
import EritreaSvg from "@/assets/svg/flags/eritreaSvg";
import EstoniaSvg from "@/assets/svg/flags/estoniaSvg";
import EthiopiaSvg from "@/assets/svg/flags/ethiopiaSvg";
import EuropeanunionSvg from "@/assets/svg/flags/european unionSvg";
import FalklandislandsSvg from "@/assets/svg/flags/falkland islandsSvg";
import FaroeislandsSvg from "@/assets/svg/flags/faroe islandsSvg";
import FijiSvg from "@/assets/svg/flags/fijiSvg";
import FinlandSvg from "@/assets/svg/flags/finlandSvg";
import FranceSvg from "@/assets/svg/flags/franceSvg";
import FrenchpolynesiaSvg from "@/assets/svg/flags/french polynesiaSvg";
import GabonSvg from "@/assets/svg/flags/gabonSvg";
import GalapagosislandsSvg from "@/assets/svg/flags/galapagos islandsSvg";
import GambiaSvg from "@/assets/svg/flags/gambiaSvg";
import GeorgiaSvg from "@/assets/svg/flags/georgiaSvg";
import GermanySvg from "@/assets/svg/flags/germanySvg";
import GhanaSvg from "@/assets/svg/flags/ghanaSvg";
import GibraltarSvg from "@/assets/svg/flags/gibraltarSvg";
import GreeceSvg from "@/assets/svg/flags/greeceSvg";
import GreenlandSvg from "@/assets/svg/flags/greenlandSvg";
import GrenadaSvg from "@/assets/svg/flags/grenadaSvg";
import GuamSvg from "@/assets/svg/flags/guamSvg";
import GuatemalaSvg from "@/assets/svg/flags/guatemalaSvg";
import GuernseySvg from "@/assets/svg/flags/guernseySvg";
import GuineaSvg from "@/assets/svg/flags/guineaSvg";
import GuineabissauSvg from "@/assets/svg/flags/guinea bissauSvg";
import GuyanaSvg from "@/assets/svg/flags/guyanaSvg";
import HaitiSvg from "@/assets/svg/flags/haitiSvg";
import HawaiiSvg from "@/assets/svg/flags/hawaiiSvg";
import HondurasSvg from "@/assets/svg/flags/hondurasSvg";
import HongkongSvg from "@/assets/svg/flags/hong kongSvg";
import HungarySvg from "@/assets/svg/flags/hungarySvg";
import IcelandSvg from "@/assets/svg/flags/icelandSvg";
import IndiaSvg from "@/assets/svg/flags/indiaSvg";
import IndonesiaSvg from "@/assets/svg/flags/indonesiaSvg";
import IranSvg from "@/assets/svg/flags/iranSvg";
import IraqSvg from "@/assets/svg/flags/iraqSvg";
import IrelandSvg from "@/assets/svg/flags/irelandSvg";
import IsleofmanSvg from "@/assets/svg/flags/isle of manSvg";
import IsraelSvg from "@/assets/svg/flags/israelSvg";
import ItalySvg from "@/assets/svg/flags/italySvg";
import IvorycoastSvg from "@/assets/svg/flags/ivory coastSvg";
import JamaicaSvg from "@/assets/svg/flags/jamaicaSvg";
import JapanSvg from "@/assets/svg/flags/japanSvg";
import JerseySvg from "@/assets/svg/flags/jerseySvg";
import JordanSvg from "@/assets/svg/flags/jordanSvg";
import KazakhstanSvg from "@/assets/svg/flags/kazakhstanSvg";
import KenyaSvg from "@/assets/svg/flags/kenyaSvg";
import KiribatiSvg from "@/assets/svg/flags/kiribatiSvg";
import KosovoSvg from "@/assets/svg/flags/kosovoSvg";
import KuwaitSvg from "@/assets/svg/flags/kuwaitSvg";
import KyrgyzstanSvg from "@/assets/svg/flags/kyrgyzstanSvg";
import LaosSvg from "@/assets/svg/flags/laosSvg";
import LatviaSvg from "@/assets/svg/flags/latviaSvg";
import LebanonSvg from "@/assets/svg/flags/lebanonSvg";
import LesothoSvg from "@/assets/svg/flags/lesothoSvg";
import LiberiaSvg from "@/assets/svg/flags/liberiaSvg";
import LibyaSvg from "@/assets/svg/flags/libyaSvg";
import LiechtensteinSvg from "@/assets/svg/flags/liechtensteinSvg";
import LithuaniaSvg from "@/assets/svg/flags/lithuaniaSvg";
import LuxembourgSvg from "@/assets/svg/flags/luxembourgSvg";
import MacaoSvg from "@/assets/svg/flags/macaoSvg";
import MadagascarSvg from "@/assets/svg/flags/madagascarSvg";
import MadeiraSvg from "@/assets/svg/flags/madeiraSvg";
import MalawiSvg from "@/assets/svg/flags/malawiSvg";
import MalaysiaSvg from "@/assets/svg/flags/malaysiaSvg";
import MaldivesSvg from "@/assets/svg/flags/maldivesSvg";
import MaliSvg from "@/assets/svg/flags/maliSvg";
import MaltaSvg from "@/assets/svg/flags/maltaSvg";
import MarshallislandSvg from "@/assets/svg/flags/marshall islandSvg";
import MartiniqueSvg from "@/assets/svg/flags/martiniqueSvg";
import MauritaniaSvg from "@/assets/svg/flags/mauritaniaSvg";
import MauritiusSvg from "@/assets/svg/flags/mauritiusSvg";
import MelillaSvg from "@/assets/svg/flags/melillaSvg";
import MexicoSvg from "@/assets/svg/flags/mexicoSvg";
import MicronesiaSvg from "@/assets/svg/flags/micronesiaSvg";
import MoldovaSvg from "@/assets/svg/flags/moldovaSvg";
import MonacoSvg from "@/assets/svg/flags/monacoSvg";
import MongoliaSvg from "@/assets/svg/flags/mongoliaSvg";
import MontenegroSvg from "@/assets/svg/flags/montenegroSvg";
import MontserratSvg from "@/assets/svg/flags/montserratSvg";
import MoroccoSvg from "@/assets/svg/flags/moroccoSvg";
import MozambiqueSvg from "@/assets/svg/flags/mozambiqueSvg";
import MyanmarSvg from "@/assets/svg/flags/myanmarSvg";
import NamibiaSvg from "@/assets/svg/flags/namibiaSvg";
import NatoSvg from "@/assets/svg/flags/natoSvg";
import NauruSvg from "@/assets/svg/flags/nauruSvg";
import NepalSvg from "@/assets/svg/flags/nepalSvg";
import NetherlandsSvg from "@/assets/svg/flags/netherlandsSvg";
import NewzealandSvg from "@/assets/svg/flags/new zealandSvg";
import NicaraguaSvg from "@/assets/svg/flags/nicaraguaSvg";
import NigerSvg from "@/assets/svg/flags/nigerSvg";
import NigeriaSvg from "@/assets/svg/flags/nigeriaSvg";
import NiueSvg from "@/assets/svg/flags/niueSvg";
import NorfolkislandSvg from "@/assets/svg/flags/norfolk islandSvg";
import NorthkoreaSvg from "@/assets/svg/flags/north koreaSvg";
import NortherncyprusSvg from "@/assets/svg/flags/northern cyprusSvg";
import NorthernmarianasislandsSvg from "@/assets/svg/flags/northern marianas islandsSvg";
import NorwaySvg from "@/assets/svg/flags/norwaySvg";
import OmanSvg from "@/assets/svg/flags/omanSvg";
import OrkneyislandsSvg from "@/assets/svg/flags/orkney islandsSvg";
import OssetiaSvg from "@/assets/svg/flags/ossetiaSvg";
import PakistanSvg from "@/assets/svg/flags/pakistanSvg";
import PalauSvg from "@/assets/svg/flags/palauSvg";
import PalestineSvg from "@/assets/svg/flags/palestineSvg";
import PanamaSvg from "@/assets/svg/flags/panamaSvg";
import PapuanewguineaSvg from "@/assets/svg/flags/papua new guineaSvg";
import ParaguaySvg from "@/assets/svg/flags/paraguaySvg";
import PeruSvg from "@/assets/svg/flags/peruSvg";
import PhilippinesSvg from "@/assets/svg/flags/philippinesSvg";
import PitcairnislandsSvg from "@/assets/svg/flags/pitcairn islandsSvg";
import PolandSvg from "@/assets/svg/flags/polandSvg";
import PortugalSvg from "@/assets/svg/flags/portugalSvg";
import PuertoricoSvg from "@/assets/svg/flags/puerto ricoSvg";
import QatarSvg from "@/assets/svg/flags/qatarSvg";
import RapanuiSvg from "@/assets/svg/flags/Rapa NuiSvg";
import RepublicofmacedoniaSvg from "@/assets/svg/flags/republic of macedoniaSvg";
import RepublicofthecongoSvg from "@/assets/svg/flags/republic of the congoSvg";
import RomaniaSvg from "@/assets/svg/flags/romaniaSvg";
import RussiaSvg from "@/assets/svg/flags/russiaSvg";
import RwandaSvg from "@/assets/svg/flags/rwandaSvg";
import SabaislandSvg from "@/assets/svg/flags/saba islandSvg";
import SahrawiarabdemocraticrepublicSvg from "@/assets/svg/flags/sahrawi arab democratic republicSvg";
import SamoaSvg from "@/assets/svg/flags/samoaSvg";
import SanmarinoSvg from "@/assets/svg/flags/san marinoSvg";
import SaotomeandprinceSvg from "@/assets/svg/flags/sao tome and princeSvg";
import SardiniaSvg from "@/assets/svg/flags/sardiniaSvg";
import SaudiarabiaSvg from "@/assets/svg/flags/saudi arabiaSvg";
import ScotlandSvg from "@/assets/svg/flags/scotlandSvg";
import SenegalSvg from "@/assets/svg/flags/senegalSvg";
import SerbiaSvg from "@/assets/svg/flags/serbiaSvg";
import SeychellesSvg from "@/assets/svg/flags/seychellesSvg";
import SierraleoneSvg from "@/assets/svg/flags/sierra leoneSvg";
import SingaporeSvg from "@/assets/svg/flags/singaporeSvg";
import SinteustatiusSvg from "@/assets/svg/flags/sint eustatiusSvg";
import SintmaartenSvg from "@/assets/svg/flags/sint maartenSvg";
import SlovakiaSvg from "@/assets/svg/flags/slovakiaSvg";
import SloveniaSvg from "@/assets/svg/flags/sloveniaSvg";
import SolomonislandsSvg from "@/assets/svg/flags/solomon islandsSvg";
import SomaliaSvg from "@/assets/svg/flags/somaliaSvg";
import SomalilandSvg from "@/assets/svg/flags/somalilandSvg";
import SouthafricaSvg from "@/assets/svg/flags/south africaSvg";
import SouthkoreaSvg from "@/assets/svg/flags/south koreaSvg";
import SouthsudanSvg from "@/assets/svg/flags/south sudanSvg";
import SpainSvg from "@/assets/svg/flags/spainSvg";
import SrilankaSvg from "@/assets/svg/flags/sri lankaSvg";
import StbartsSvg from "@/assets/svg/flags/st bartsSvg";
import StluciaSvg from "@/assets/svg/flags/st luciaSvg";
import StvincentandthegrenadinesSvg from "@/assets/svg/flags/st vincent and the grenadinesSvg";
import SudanSvg from "@/assets/svg/flags/sudanSvg";
import SurinameSvg from "@/assets/svg/flags/surinameSvg";
import SwazilandSvg from "@/assets/svg/flags/swazilandSvg";
import SwedenSvg from "@/assets/svg/flags/swedenSvg";
import SwitzerlandSvg from "@/assets/svg/flags/switzerlandSvg";
import SyriaSvg from "@/assets/svg/flags/syriaSvg";
import TaiwanSvg from "@/assets/svg/flags/taiwanSvg";
import TajikistanSvg from "@/assets/svg/flags/tajikistanSvg";
import TanzaniaSvg from "@/assets/svg/flags/tanzaniaSvg";
import ThailandSvg from "@/assets/svg/flags/thailandSvg";
import TibetSvg from "@/assets/svg/flags/tibetSvg";
import TogoSvg from "@/assets/svg/flags/togoSvg";
import TokelauSvg from "@/assets/svg/flags/tokelauSvg";
import TongaSvg from "@/assets/svg/flags/tongaSvg";
import TransnistriaSvg from "@/assets/svg/flags/transnistriaSvg";
import TrinidadandtobagoSvg from "@/assets/svg/flags/trinidad and tobagoSvg";
import TunisiaSvg from "@/assets/svg/flags/tunisiaSvg";
import TurkeySvg from "@/assets/svg/flags/turkeySvg";
import TurkmenistanSvg from "@/assets/svg/flags/turkmenistanSvg";
import TurksandcaicosSvg from "@/assets/svg/flags/turks and caicosSvg";
import TuvaluSvg from "@/assets/svg/flags/tuvaluSvg";
import UgandaSvg from "@/assets/svg/flags/ugandaSvg";
import UkraineSvg from "@/assets/svg/flags/ukraineSvg";
import UnitedarabemiratesSvg from "@/assets/svg/flags/united arab emiratesSvg";
import UnitedkingdomSvg from "@/assets/svg/flags/united kingdomSvg";
import UnitednationsSvg from "@/assets/svg/flags/united nationsSvg";
import UnitedstatesSvg from "@/assets/svg/flags/united statesSvg";
import UruguaySvg from "@/assets/svg/flags/uruguaySvg";
import UzbekistánSvg from "@/assets/svg/flags/uzbekistanSvg";
import VanuatuSvg from "@/assets/svg/flags/vanuatuSvg";
import VaticancitySvg from "@/assets/svg/flags/vatican citySvg";
import VenezuelaSvg from "@/assets/svg/flags/venezuelaSvg";
import VietnamSvg from "@/assets/svg/flags/vietnamSvg";
import VirginislandsSvg from "@/assets/svg/flags/virgin islandsSvg";
import WalesSvg from "@/assets/svg/flags/walesSvg";
import YemenSvg from "@/assets/svg/flags/yemenSvg";
import ZambiaSvg from "@/assets/svg/flags/zambiaSvg";
import ZimbabweSvg from "@/assets/svg/flags/zimbabweSvg";

type MarketItemType = {
  id: number;
  name: string;
  exchanges: string;
  icon: ReactElement;
};

export const mockMarkets: MarketItemType[] = [
  { id: 1, name: "Abkhazia", exchanges: "NASDAQ, NYSE", icon: <AbkhaziaSvg /> },
  { id: 2, name: "Afghanistan", exchanges: "NASDAQ, NYSE", icon: <AfghanistanSvg /> },
  { id: 3, name: "Aland Islands", exchanges: "NASDAQ, NYSE", icon: <AlandislandsSvg /> },
  { id: 4, name: "Albania", exchanges: "NASDAQ, NYSE", icon: <AlbaniaSvg /> },
  { id: 5, name: "Algeria", exchanges: "NASDAQ, NYSE", icon: <AlgeriaSvg /> },
  { id: 6, name: "American Samoa", exchanges: "NASDAQ, NYSE", icon: <AmericansamoaSvg /> },
  { id: 7, name: "Andorra", exchanges: "NASDAQ, NYSE", icon: <AndorraSvg /> },
  { id: 8, name: "Angola", exchanges: "NASDAQ, NYSE", icon: <AngolaSvg /> },
  { id: 9, name: "Anguilla", exchanges: "NASDAQ, NYSE", icon: <AnguillaSvg /> },
  {
    id: 10,
    name: "Antigua And Barbuda",
    exchanges: "NASDAQ, NYSE",
    icon: <AntiguaandbarbudaSvg />,
  },
  { id: 11, name: "Argentina", exchanges: "NASDAQ, NYSE", icon: <ArgentinaSvg /> },
  { id: 12, name: "Armenia", exchanges: "NASDAQ, NYSE", icon: <ArmeniaSvg /> },
  { id: 13, name: "Aruba", exchanges: "NASDAQ, NYSE", icon: <ArubaSvg /> },
  { id: 14, name: "Australia", exchanges: "NASDAQ, NYSE", icon: <AustraliaSvg /> },
  { id: 15, name: "Austria", exchanges: "NASDAQ, NYSE", icon: <AustriaSvg /> },
  { id: 16, name: "Azerbaijan", exchanges: "NASDAQ, NYSE", icon: <AzerbaijanSvg /> },
  { id: 17, name: "Azores Islands", exchanges: "NASDAQ, NYSE", icon: <AzoresislandsSvg /> },
  { id: 18, name: "Bahamas", exchanges: "NASDAQ, NYSE", icon: <BahamasSvg /> },
  { id: 19, name: "Bahrain", exchanges: "NASDAQ, NYSE", icon: <BahrainSvg /> },
  { id: 20, name: "Balearic Islands", exchanges: "NASDAQ, NYSE", icon: <BalearicislandsSvg /> },
  { id: 21, name: "Bangladesh", exchanges: "NASDAQ, NYSE", icon: <BangladeshSvg /> },
  { id: 22, name: "Barbados", exchanges: "NASDAQ, NYSE", icon: <BarbadosSvg /> },
  { id: 23, name: "Basque Country", exchanges: "NASDAQ, NYSE", icon: <BasquecountrySvg /> },
  { id: 24, name: "Belarus", exchanges: "NASDAQ, NYSE", icon: <BelarusSvg /> },
  { id: 25, name: "Belgium", exchanges: "NASDAQ, NYSE", icon: <BelgiumSvg /> },
  { id: 26, name: "Belize", exchanges: "NASDAQ, NYSE", icon: <BelizeSvg /> },
  { id: 27, name: "Benin", exchanges: "NASDAQ, NYSE", icon: <BeninSvg /> },
  { id: 28, name: "Bermuda", exchanges: "NASDAQ, NYSE", icon: <BermudaSvg /> },
  { id: 29, name: "Bhutan", exchanges: "NASDAQ, NYSE", icon: <BhutanSvg /> },
  { id: 30, name: "Bolivia", exchanges: "NASDAQ, NYSE", icon: <BoliviaSvg /> },
  { id: 31, name: "Bonaire", exchanges: "NASDAQ, NYSE", icon: <BonaireSvg /> },
  {
    id: 32,
    name: "Bosnia And Herzegovina",
    exchanges: "NASDAQ, NYSE",
    icon: <BosniaandherzegovinaSvg />,
  },
  { id: 33, name: "Botswana", exchanges: "NASDAQ, NYSE", icon: <BotswanaSvg /> },
  { id: 34, name: "Brazil", exchanges: "NASDAQ, NYSE", icon: <BrazilSvg /> },
  { id: 35, name: "British Columbia", exchanges: "NASDAQ, NYSE", icon: <BritishcolumbiaSvg /> },
  {
    id: 36,
    name: "British Indian Ocean Territory",
    exchanges: "NASDAQ, NYSE",
    icon: <BritishindianoceanterritorySvg />,
  },
  {
    id: 37,
    name: "British Virgin Islands",
    exchanges: "NASDAQ, NYSE",
    icon: <BritishvirginislandsSvg />,
  },
  { id: 38, name: "Brunei", exchanges: "NASDAQ, NYSE", icon: <BruneiSvg /> },
  { id: 39, name: "Bulgaria", exchanges: "NASDAQ, NYSE", icon: <BulgariaSvg /> },
  { id: 40, name: "Burkina Faso", exchanges: "NASDAQ, NYSE", icon: <BurkinafasoSvg /> },
  { id: 41, name: "Burundi", exchanges: "NASDAQ, NYSE", icon: <BurundiSvg /> },
  { id: 42, name: "Cambodia", exchanges: "NASDAQ, NYSE", icon: <CambodiaSvg /> },
  { id: 43, name: "Cameroon", exchanges: "NASDAQ, NYSE", icon: <CameroonSvg /> },
  { id: 44, name: "Canada", exchanges: "NASDAQ, NYSE", icon: <CanadaSvg /> },
  { id: 45, name: "Canary Islands", exchanges: "NASDAQ, NYSE", icon: <CanaryislandsSvg /> },
  { id: 46, name: "Cape Verde", exchanges: "NASDAQ, NYSE", icon: <CapeverdeSvg /> },
  { id: 47, name: "Cayman Islands", exchanges: "NASDAQ, NYSE", icon: <CaymanislandsSvg /> },
  {
    id: 48,
    name: "Central African Republic",
    exchanges: "NASDAQ, NYSE",
    icon: <CentralafricanrepublicSvg />,
  },
  { id: 49, name: "Ceuta", exchanges: "NASDAQ, NYSE", icon: <CeutaSvg /> },
  { id: 50, name: "Chad", exchanges: "NASDAQ, NYSE", icon: <ChadSvg /> },
  { id: 51, name: "Chile", exchanges: "NASDAQ, NYSE", icon: <ChileSvg /> },
  { id: 52, name: "China", exchanges: "NASDAQ, NYSE", icon: <ChinaSvg /> },
  { id: 53, name: "Cocos Island", exchanges: "NASDAQ, NYSE", icon: <CocosislandSvg /> },
  { id: 54, name: "Colombia", exchanges: "NASDAQ, NYSE", icon: <ColombiaSvg /> },
  { id: 55, name: "Comoros", exchanges: "NASDAQ, NYSE", icon: <ComorosSvg /> },
  { id: 56, name: "Cook Islands", exchanges: "NASDAQ, NYSE", icon: <CookislandsSvg /> },
  { id: 57, name: "Corsica", exchanges: "NASDAQ, NYSE", icon: <CorsicaSvg /> },
  { id: 58, name: "Costa Rica", exchanges: "NASDAQ, NYSE", icon: <CostaricaSvg /> },
  { id: 59, name: "Croatia", exchanges: "NASDAQ, NYSE", icon: <CroatiaSvg /> },
  { id: 60, name: "Cuba", exchanges: "NASDAQ, NYSE", icon: <CubaSvg /> },
  { id: 61, name: "Curacao", exchanges: "NASDAQ, NYSE", icon: <CuracaoSvg /> },
  { id: 62, name: "Cyprus", exchanges: "NASDAQ, NYSE", icon: <CyprusSvg /> },
  { id: 63, name: "Czech Republic", exchanges: "NASDAQ, NYSE", icon: <CzechrepublicSvg /> },
  {
    id: 64,
    name: "Democratic Republic Of Congo",
    exchanges: "NASDAQ, NYSE",
    icon: <DemocraticrepublicofcongoSvg />,
  },
  { id: 65, name: "Denmark", exchanges: "NASDAQ, NYSE", icon: <DenmarkSvg /> },
  { id: 66, name: "Djibouti", exchanges: "NASDAQ, NYSE", icon: <DjiboutiSvg /> },
  { id: 67, name: "Dominica", exchanges: "NASDAQ, NYSE", icon: <DominicaSvg /> },
  { id: 68, name: "Dominican Republic", exchanges: "NASDAQ, NYSE", icon: <DominicanrepublicSvg /> },
  { id: 69, name: "East Timor", exchanges: "NASDAQ, NYSE", icon: <EasttimorSvg /> },
  { id: 70, name: "Ecuador", exchanges: "NASDAQ, NYSE", icon: <EcuadorSvg /> },
  { id: 71, name: "Egypt", exchanges: "NASDAQ, NYSE", icon: <EgyptSvg /> },
  { id: 72, name: "El Salvador", exchanges: "NASDAQ, NYSE", icon: <ElsalvadorSvg /> },
  { id: 73, name: "England", exchanges: "NASDAQ, NYSE", icon: <EnglandSvg /> },
  { id: 74, name: "Equatorial Guinea", exchanges: "NASDAQ, NYSE", icon: <EquatorialguineaSvg /> },
  { id: 75, name: "Eritrea", exchanges: "NASDAQ, NYSE", icon: <EritreaSvg /> },
  { id: 76, name: "Estonia", exchanges: "NASDAQ, NYSE", icon: <EstoniaSvg /> },
  { id: 77, name: "Ethiopia", exchanges: "NASDAQ, NYSE", icon: <EthiopiaSvg /> },
  { id: 78, name: "European Union", exchanges: "NASDAQ, NYSE", icon: <EuropeanunionSvg /> },
  { id: 79, name: "Falkland Islands", exchanges: "NASDAQ, NYSE", icon: <FalklandislandsSvg /> },
  { id: 80, name: "Faroe Islands", exchanges: "NASDAQ, NYSE", icon: <FaroeislandsSvg /> },
  { id: 81, name: "Fiji", exchanges: "NASDAQ, NYSE", icon: <FijiSvg /> },
  { id: 82, name: "Finland", exchanges: "NASDAQ, NYSE", icon: <FinlandSvg /> },
  { id: 83, name: "France", exchanges: "NASDAQ, NYSE", icon: <FranceSvg /> },
  { id: 84, name: "French Polynesia", exchanges: "NASDAQ, NYSE", icon: <FrenchpolynesiaSvg /> },
  { id: 85, name: "Gabon", exchanges: "NASDAQ, NYSE", icon: <GabonSvg /> },
  { id: 86, name: "Galapagos Islands", exchanges: "NASDAQ, NYSE", icon: <GalapagosislandsSvg /> },
  { id: 87, name: "Gambia", exchanges: "NASDAQ, NYSE", icon: <GambiaSvg /> },
  { id: 88, name: "Georgia", exchanges: "NASDAQ, NYSE", icon: <GeorgiaSvg /> },
  { id: 89, name: "Germany", exchanges: "NASDAQ, NYSE", icon: <GermanySvg /> },
  { id: 90, name: "Ghana", exchanges: "NASDAQ, NYSE", icon: <GhanaSvg /> },
  { id: 91, name: "Gibraltar", exchanges: "NASDAQ, NYSE", icon: <GibraltarSvg /> },
  { id: 92, name: "Greece", exchanges: "NASDAQ, NYSE", icon: <GreeceSvg /> },
  { id: 93, name: "Greenland", exchanges: "NASDAQ, NYSE", icon: <GreenlandSvg /> },
  { id: 94, name: "Grenada", exchanges: "NASDAQ, NYSE", icon: <GrenadaSvg /> },
  { id: 95, name: "Guam", exchanges: "NASDAQ, NYSE", icon: <GuamSvg /> },
  { id: 96, name: "Guatemala", exchanges: "NASDAQ, NYSE", icon: <GuatemalaSvg /> },
  { id: 97, name: "Guernsey", exchanges: "NASDAQ, NYSE", icon: <GuernseySvg /> },
  { id: 98, name: "Guinea", exchanges: "NASDAQ, NYSE", icon: <GuineaSvg /> },
  { id: 99, name: "Guinea Bissau", exchanges: "NASDAQ, NYSE", icon: <GuineabissauSvg /> },
  { id: 100, name: "Guyana", exchanges: "NASDAQ, NYSE", icon: <GuyanaSvg /> },
  { id: 101, name: "Haiti", exchanges: "NASDAQ, NYSE", icon: <HaitiSvg /> },
  { id: 102, name: "Hawaii", exchanges: "NASDAQ, NYSE", icon: <HawaiiSvg /> },
  { id: 103, name: "Honduras", exchanges: "NASDAQ, NYSE", icon: <HondurasSvg /> },
  { id: 104, name: "Hong Kong", exchanges: "NASDAQ, NYSE", icon: <HongkongSvg /> },
  { id: 105, name: "Hungary", exchanges: "NASDAQ, NYSE", icon: <HungarySvg /> },
  { id: 106, name: "Iceland", exchanges: "NASDAQ, NYSE", icon: <IcelandSvg /> },
  { id: 107, name: "India", exchanges: "NASDAQ, NYSE", icon: <IndiaSvg /> },
  { id: 108, name: "Indonesia", exchanges: "NASDAQ, NYSE", icon: <IndonesiaSvg /> },
  { id: 109, name: "Iran", exchanges: "NASDAQ, NYSE", icon: <IranSvg /> },
  { id: 110, name: "Iraq", exchanges: "NASDAQ, NYSE", icon: <IraqSvg /> },
  { id: 111, name: "Ireland", exchanges: "NASDAQ, NYSE", icon: <IrelandSvg /> },
  { id: 112, name: "Isle Of Man", exchanges: "NASDAQ, NYSE", icon: <IsleofmanSvg /> },
  { id: 113, name: "Israel", exchanges: "NASDAQ, NYSE", icon: <IsraelSvg /> },
  { id: 114, name: "Italy", exchanges: "NASDAQ, NYSE", icon: <ItalySvg /> },
  { id: 115, name: "Ivory Coast", exchanges: "NASDAQ, NYSE", icon: <IvorycoastSvg /> },
  { id: 116, name: "Jamaica", exchanges: "NASDAQ, NYSE", icon: <JamaicaSvg /> },
  { id: 117, name: "Japan", exchanges: "NASDAQ, NYSE", icon: <JapanSvg /> },
  { id: 118, name: "Jersey", exchanges: "NASDAQ, NYSE", icon: <JerseySvg /> },
  { id: 119, name: "Jordan", exchanges: "NASDAQ, NYSE", icon: <JordanSvg /> },
  { id: 120, name: "Kazakhstan", exchanges: "NASDAQ, NYSE", icon: <KazakhstanSvg /> },
  { id: 121, name: "Kenya", exchanges: "NASDAQ, NYSE", icon: <KenyaSvg /> },
  { id: 122, name: "Kiribati", exchanges: "NASDAQ, NYSE", icon: <KiribatiSvg /> },
  { id: 123, name: "Kosovo", exchanges: "NASDAQ, NYSE", icon: <KosovoSvg /> },
  { id: 124, name: "Kuwait", exchanges: "NASDAQ, NYSE", icon: <KuwaitSvg /> },
  { id: 125, name: "Kyrgyzstan", exchanges: "NASDAQ, NYSE", icon: <KyrgyzstanSvg /> },
  { id: 126, name: "Laos", exchanges: "NASDAQ, NYSE", icon: <LaosSvg /> },
  { id: 127, name: "Latvia", exchanges: "NASDAQ, NYSE", icon: <LatviaSvg /> },
  { id: 128, name: "Lebanon", exchanges: "NASDAQ, NYSE", icon: <LebanonSvg /> },
  { id: 129, name: "Lesotho", exchanges: "NASDAQ, NYSE", icon: <LesothoSvg /> },
  { id: 130, name: "Liberia", exchanges: "NASDAQ, NYSE", icon: <LiberiaSvg /> },
  { id: 131, name: "Libya", exchanges: "NASDAQ, NYSE", icon: <LibyaSvg /> },
  { id: 132, name: "Liechtenstein", exchanges: "NASDAQ, NYSE", icon: <LiechtensteinSvg /> },
  { id: 133, name: "Lithuania", exchanges: "NASDAQ, NYSE", icon: <LithuaniaSvg /> },
  { id: 134, name: "Luxembourg", exchanges: "NASDAQ, NYSE", icon: <LuxembourgSvg /> },
  { id: 135, name: "Macao", exchanges: "NASDAQ, NYSE", icon: <MacaoSvg /> },
  { id: 136, name: "Madagascar", exchanges: "NASDAQ, NYSE", icon: <MadagascarSvg /> },
  { id: 137, name: "Madeira", exchanges: "NASDAQ, NYSE", icon: <MadeiraSvg /> },
  { id: 138, name: "Malawi", exchanges: "NASDAQ, NYSE", icon: <MalawiSvg /> },
  { id: 139, name: "Malaysia", exchanges: "NASDAQ, NYSE", icon: <MalaysiaSvg /> },
  { id: 140, name: "Maldives", exchanges: "NASDAQ, NYSE", icon: <MaldivesSvg /> },
  { id: 141, name: "Mali", exchanges: "NASDAQ, NYSE", icon: <MaliSvg /> },
  { id: 142, name: "Malta", exchanges: "NASDAQ, NYSE", icon: <MaltaSvg /> },
  { id: 143, name: "Marshall Island", exchanges: "NASDAQ, NYSE", icon: <MarshallislandSvg /> },
  { id: 144, name: "Martinique", exchanges: "NASDAQ, NYSE", icon: <MartiniqueSvg /> },
  { id: 145, name: "Mauritania", exchanges: "NASDAQ, NYSE", icon: <MauritaniaSvg /> },
  { id: 146, name: "Mauritius", exchanges: "NASDAQ, NYSE", icon: <MauritiusSvg /> },
  { id: 147, name: "Melilla", exchanges: "NASDAQ, NYSE", icon: <MelillaSvg /> },
  { id: 148, name: "Mexico", exchanges: "NASDAQ, NYSE", icon: <MexicoSvg /> },
  { id: 149, name: "Micronesia", exchanges: "NASDAQ, NYSE", icon: <MicronesiaSvg /> },
  { id: 150, name: "Moldova", exchanges: "NASDAQ, NYSE", icon: <MoldovaSvg /> },
  { id: 151, name: "Monaco", exchanges: "NASDAQ, NYSE", icon: <MonacoSvg /> },
  { id: 152, name: "Mongolia", exchanges: "NASDAQ, NYSE", icon: <MongoliaSvg /> },
  { id: 153, name: "Montenegro", exchanges: "NASDAQ, NYSE", icon: <MontenegroSvg /> },
  { id: 154, name: "Montserrat", exchanges: "NASDAQ, NYSE", icon: <MontserratSvg /> },
  { id: 155, name: "Morocco", exchanges: "NASDAQ, NYSE", icon: <MoroccoSvg /> },
  { id: 156, name: "Mozambique", exchanges: "NASDAQ, NYSE", icon: <MozambiqueSvg /> },
  { id: 157, name: "Myanmar", exchanges: "NASDAQ, NYSE", icon: <MyanmarSvg /> },
  { id: 158, name: "Namibia", exchanges: "NASDAQ, NYSE", icon: <NamibiaSvg /> },
  { id: 159, name: "Nato", exchanges: "NASDAQ, NYSE", icon: <NatoSvg /> },
  { id: 160, name: "Nauru", exchanges: "NASDAQ, NYSE", icon: <NauruSvg /> },
  { id: 161, name: "Nepal", exchanges: "NASDAQ, NYSE", icon: <NepalSvg /> },
  { id: 162, name: "Netherlands", exchanges: "NASDAQ, NYSE", icon: <NetherlandsSvg /> },
  { id: 163, name: "New Zealand", exchanges: "NASDAQ, NYSE", icon: <NewzealandSvg /> },
  { id: 164, name: "Nicaragua", exchanges: "NASDAQ, NYSE", icon: <NicaraguaSvg /> },
  { id: 165, name: "Niger", exchanges: "NASDAQ, NYSE", icon: <NigerSvg /> },
  { id: 166, name: "Nigeria", exchanges: "NASDAQ, NYSE", icon: <NigeriaSvg /> },
  { id: 167, name: "Niue", exchanges: "NASDAQ, NYSE", icon: <NiueSvg /> },
  { id: 168, name: "Norfolk Island", exchanges: "NASDAQ, NYSE", icon: <NorfolkislandSvg /> },
  { id: 169, name: "North Korea", exchanges: "NASDAQ, NYSE", icon: <NorthkoreaSvg /> },
  { id: 170, name: "Northern Cyprus", exchanges: "NASDAQ, NYSE", icon: <NortherncyprusSvg /> },
  {
    id: 171,
    name: "Northern Marianas Islands",
    exchanges: "NASDAQ, NYSE",
    icon: <NorthernmarianasislandsSvg />,
  },
  { id: 172, name: "Norway", exchanges: "NASDAQ, NYSE", icon: <NorwaySvg /> },
  { id: 173, name: "Oman", exchanges: "NASDAQ, NYSE", icon: <OmanSvg /> },
  { id: 174, name: "Orkney Islands", exchanges: "NASDAQ, NYSE", icon: <OrkneyislandsSvg /> },
  { id: 175, name: "Ossetia", exchanges: "NASDAQ, NYSE", icon: <OssetiaSvg /> },
  { id: 176, name: "Pakistan", exchanges: "NASDAQ, NYSE", icon: <PakistanSvg /> },
  { id: 177, name: "Palau", exchanges: "NASDAQ, NYSE", icon: <PalauSvg /> },
  { id: 178, name: "Palestine", exchanges: "NASDAQ, NYSE", icon: <PalestineSvg /> },
  { id: 179, name: "Panama", exchanges: "NASDAQ, NYSE", icon: <PanamaSvg /> },
  { id: 180, name: "Papua New Guinea", exchanges: "NASDAQ, NYSE", icon: <PapuanewguineaSvg /> },
  { id: 181, name: "Paraguay", exchanges: "NASDAQ, NYSE", icon: <ParaguaySvg /> },
  { id: 182, name: "Peru", exchanges: "NASDAQ, NYSE", icon: <PeruSvg /> },
  { id: 183, name: "Philippines", exchanges: "NASDAQ, NYSE", icon: <PhilippinesSvg /> },
  { id: 184, name: "Pitcairn Islands", exchanges: "NASDAQ, NYSE", icon: <PitcairnislandsSvg /> },
  { id: 185, name: "Poland", exchanges: "NASDAQ, NYSE", icon: <PolandSvg /> },
  { id: 186, name: "Portugal", exchanges: "NASDAQ, NYSE", icon: <PortugalSvg /> },
  { id: 187, name: "Puerto Rico", exchanges: "NASDAQ, NYSE", icon: <PuertoricoSvg /> },
  { id: 188, name: "Qatar", exchanges: "NASDAQ, NYSE", icon: <QatarSvg /> },
  { id: 189, name: "Rapa Nui", exchanges: "NASDAQ, NYSE", icon: <RapanuiSvg /> },
  {
    id: 190,
    name: "Republic Of Macedonia",
    exchanges: "NASDAQ, NYSE",
    icon: <RepublicofmacedoniaSvg />,
  },
  {
    id: 191,
    name: "Republic Of The Congo",
    exchanges: "NASDAQ, NYSE",
    icon: <RepublicofthecongoSvg />,
  },
  { id: 192, name: "Romania", exchanges: "NASDAQ, NYSE", icon: <RomaniaSvg /> },
  { id: 193, name: "Russia", exchanges: "NASDAQ, NYSE", icon: <RussiaSvg /> },
  { id: 194, name: "Rwanda", exchanges: "NASDAQ, NYSE", icon: <RwandaSvg /> },
  { id: 195, name: "Saba Island", exchanges: "NASDAQ, NYSE", icon: <SabaislandSvg /> },
  {
    id: 196,
    name: "Sahrawi Arab Democratic Republic",
    exchanges: "NASDAQ, NYSE",
    icon: <SahrawiarabdemocraticrepublicSvg />,
  },
  { id: 197, name: "Samoa", exchanges: "NASDAQ, NYSE", icon: <SamoaSvg /> },
  { id: 198, name: "San Marino", exchanges: "NASDAQ, NYSE", icon: <SanmarinoSvg /> },
  {
    id: 199,
    name: "Sao Tome And Prince",
    exchanges: "NASDAQ, NYSE",
    icon: <SaotomeandprinceSvg />,
  },
  { id: 200, name: "Sardinia", exchanges: "NASDAQ, NYSE", icon: <SardiniaSvg /> },
  { id: 201, name: "Saudi Arabia", exchanges: "NASDAQ, NYSE", icon: <SaudiarabiaSvg /> },
  { id: 202, name: "Scotland", exchanges: "NASDAQ, NYSE", icon: <ScotlandSvg /> },
  { id: 203, name: "Senegal", exchanges: "NASDAQ, NYSE", icon: <SenegalSvg /> },
  { id: 204, name: "Serbia", exchanges: "NASDAQ, NYSE", icon: <SerbiaSvg /> },
  { id: 205, name: "Seychelles", exchanges: "NASDAQ, NYSE", icon: <SeychellesSvg /> },
  { id: 206, name: "Sierra Leone", exchanges: "NASDAQ, NYSE", icon: <SierraleoneSvg /> },
  { id: 207, name: "Singapore", exchanges: "NASDAQ, NYSE", icon: <SingaporeSvg /> },
  { id: 208, name: "Sint Eustatius", exchanges: "NASDAQ, NYSE", icon: <SinteustatiusSvg /> },
  { id: 209, name: "Sint Maarten", exchanges: "NASDAQ, NYSE", icon: <SintmaartenSvg /> },
  { id: 210, name: "Slovakia", exchanges: "NASDAQ, NYSE", icon: <SlovakiaSvg /> },
  { id: 211, name: "Slovenia", exchanges: "NASDAQ, NYSE", icon: <SloveniaSvg /> },
  { id: 212, name: "Solomon Islands", exchanges: "NASDAQ, NYSE", icon: <SolomonislandsSvg /> },
  { id: 213, name: "Somalia", exchanges: "NASDAQ, NYSE", icon: <SomaliaSvg /> },
  { id: 214, name: "Somaliland", exchanges: "NASDAQ, NYSE", icon: <SomalilandSvg /> },
  { id: 215, name: "South Africa", exchanges: "NASDAQ, NYSE", icon: <SouthafricaSvg /> },
  { id: 216, name: "South Korea", exchanges: "NASDAQ, NYSE", icon: <SouthkoreaSvg /> },
  { id: 217, name: "South Sudan", exchanges: "NASDAQ, NYSE", icon: <SouthsudanSvg /> },
  { id: 218, name: "Spain", exchanges: "NASDAQ, NYSE", icon: <SpainSvg /> },
  { id: 219, name: "Sri Lanka", exchanges: "NASDAQ, NYSE", icon: <SrilankaSvg /> },
  { id: 220, name: "St Barts", exchanges: "NASDAQ, NYSE", icon: <StbartsSvg /> },
  { id: 221, name: "St Lucia", exchanges: "NASDAQ, NYSE", icon: <StluciaSvg /> },
  {
    id: 222,
    name: "St Vincent And The Grenadines",
    exchanges: "NASDAQ, NYSE",
    icon: <StvincentandthegrenadinesSvg />,
  },
  { id: 223, name: "Sudan", exchanges: "NASDAQ, NYSE", icon: <SudanSvg /> },
  { id: 224, name: "Suriname", exchanges: "NASDAQ, NYSE", icon: <SurinameSvg /> },
  { id: 225, name: "Swaziland", exchanges: "NASDAQ, NYSE", icon: <SwazilandSvg /> },
  { id: 226, name: "Sweden", exchanges: "NASDAQ, NYSE", icon: <SwedenSvg /> },
  { id: 227, name: "Switzerland", exchanges: "NASDAQ, NYSE", icon: <SwitzerlandSvg /> },
  { id: 228, name: "Syria", exchanges: "NASDAQ, NYSE", icon: <SyriaSvg /> },
  { id: 229, name: "Taiwan", exchanges: "NASDAQ, NYSE", icon: <TaiwanSvg /> },
  { id: 230, name: "Tajikistan", exchanges: "NASDAQ, NYSE", icon: <TajikistanSvg /> },
  { id: 231, name: "Tanzania", exchanges: "NASDAQ, NYSE", icon: <TanzaniaSvg /> },
  { id: 232, name: "Thailand", exchanges: "NASDAQ, NYSE", icon: <ThailandSvg /> },
  { id: 233, name: "Tibet", exchanges: "NASDAQ, NYSE", icon: <TibetSvg /> },
  { id: 234, name: "Togo", exchanges: "NASDAQ, NYSE", icon: <TogoSvg /> },
  { id: 235, name: "Tokelau", exchanges: "NASDAQ, NYSE", icon: <TokelauSvg /> },
  { id: 236, name: "Tonga", exchanges: "NASDAQ, NYSE", icon: <TongaSvg /> },
  { id: 237, name: "Transnistria", exchanges: "NASDAQ, NYSE", icon: <TransnistriaSvg /> },
  {
    id: 238,
    name: "Trinidad And Tobago",
    exchanges: "NASDAQ, NYSE",
    icon: <TrinidadandtobagoSvg />,
  },
  { id: 239, name: "Tunisia", exchanges: "NASDAQ, NYSE", icon: <TunisiaSvg /> },
  { id: 240, name: "Turkey", exchanges: "NASDAQ, NYSE", icon: <TurkeySvg /> },
  { id: 241, name: "Turkmenistan", exchanges: "NASDAQ, NYSE", icon: <TurkmenistanSvg /> },
  { id: 242, name: "Turks And Caicos", exchanges: "NASDAQ, NYSE", icon: <TurksandcaicosSvg /> },
  { id: 243, name: "Tuvalu", exchanges: "NASDAQ, NYSE", icon: <TuvaluSvg /> },
  { id: 244, name: "Uganda", exchanges: "NASDAQ, NYSE", icon: <UgandaSvg /> },
  { id: 245, name: "Ukraine", exchanges: "NASDAQ, NYSE", icon: <UkraineSvg /> },
  {
    id: 246,
    name: "United Arab Emirates",
    exchanges: "NASDAQ, NYSE",
    icon: <UnitedarabemiratesSvg />,
  },
  { id: 247, name: "United Kingdom", exchanges: "NASDAQ, NYSE", icon: <UnitedkingdomSvg /> },
  { id: 248, name: "United Nations", exchanges: "NASDAQ, NYSE", icon: <UnitednationsSvg /> },
  { id: 249, name: "United States", exchanges: "NASDAQ, NYSE", icon: <UnitedstatesSvg /> },
  { id: 250, name: "Uruguay", exchanges: "NASDAQ, NYSE", icon: <UruguaySvg /> },
  { id: 251, name: "Uzbekistán", exchanges: "NASDAQ, NYSE", icon: <UzbekistánSvg /> },
  { id: 252, name: "Vanuatu", exchanges: "NASDAQ, NYSE", icon: <VanuatuSvg /> },
  { id: 253, name: "Vatican City", exchanges: "NASDAQ, NYSE", icon: <VaticancitySvg /> },
  { id: 254, name: "Venezuela", exchanges: "NASDAQ, NYSE", icon: <VenezuelaSvg /> },
  { id: 255, name: "Vietnam", exchanges: "NASDAQ, NYSE", icon: <VietnamSvg /> },
  { id: 256, name: "Virgin Islands", exchanges: "NASDAQ, NYSE", icon: <VirginislandsSvg /> },
  { id: 257, name: "Wales", exchanges: "NASDAQ, NYSE", icon: <WalesSvg /> },
  { id: 258, name: "Yemen", exchanges: "NASDAQ, NYSE", icon: <YemenSvg /> },
  { id: 259, name: "Zambia", exchanges: "NASDAQ, NYSE", icon: <ZambiaSvg /> },
  { id: 260, name: "Zimbabwe", exchanges: "NASDAQ, NYSE", icon: <ZimbabweSvg /> },
];
